
export const CREATE_COSTING_HEADER_REQUEST = 'CREATE_COSTING_HEADER_REQUEST';
export const CREATE_COSTING_HEADER_SUCCESS = 'CREATE_COSTING_HEADER_SUCCESS';
export const CREATE_COSTING_HEADER_FAILURE = 'CREATE_COSTING_HEADER_FAILURE';

export const CREATE_COSTING_HEADER_FORM = 'CREATE_COSTING_HEADER_FORM';

export const CREATE_COSTING_HEADER_DETAIL_FORM = 'CREATE_COSTING_HEADER_DETAIL_FORM';

export const CREATE_COSTING_HEADER_USERFORM_RESET = 'CREATE_COSTING_HEADER_USERFORM_RESET';

export const UPDATE_COSTING_HEADER_USERFORM_RESET = 'UPDATE_COSTING_HEADER_USERFORM_RESET';

export const FETCH_COSTING_HEADER_REQUEST = 'FETCH_COSTING_HEADER_REQUEST';
export const FETCH_COSTING_HEADER_SUCCESS = 'FETCH_COSTING_HEADER_SUCCESS';
export const FETCH_COSTING_HEADER_FAILURE = 'FETCH_COSTING_HEADER_FAILURE';

export const CREATE_COSTING_HEADER_DETAIL_REQUEST = 'CREATE_COSTING_HEADER_DETAIL_REQUEST';
export const CREATE_COSTING_HEADER_DETAIL_SUCCESS = 'CREATE_COSTING_HEADER_DETAIL_SUCCESS';
export const CREATE_COSTING_HEADER_DETAIL_FAILURE = 'CREATE_COSTING_HEADER_DETAIL_FAILURE';

export const FETCH_COSTING_SERIAL_NO_REQUEST = 'FETCH_COSTING_SERIAL_NO_REQUEST';
export const FETCH_COSTING_SERIAL_NO_SUCCESS = 'FETCH_COSTING_SERIAL_NO_SUCCESS';
export const FETCH_COSTING_SERIAL_NO_FAILURE = 'FETCH_COSTING_SERIAL_NO_FAILURE';

export const FETCH_COSTING_HEADER_MAIN_GRID_REQUEST = 'FETCH_COSTING_HEADER_MAIN_GRID_REQUEST';
export const FETCH_COSTING_HEADER_MAIN_GRID_SUCCESS = 'FETCH_COSTING_HEADER_MAIN_GRID_SUCCESS';
export const FETCH_COSTING_HEADER_MAIN_GRID_FAILURE = 'FETCH_COSTING_HEADER_MAIN_GRID_FAILURE';

export const UPDATE_COSTING_DETAIL_REQUEST = 'UPDATE_COSTING_DETAIL_REQUEST';
export const UPDATE_COSTING_DETAIL_SUCCESS = 'UPDATE_COSTING_DETAIL_SUCCESS';
export const UPDATE_COSTING_DETAIL_FAILURE = 'UPDATE_COSTING_DETAIL_FAILURE';

export const SET_EDIT_COSTING_DETAIL_DATA = 'SET_EDIT_COSTING_DETAIL_DATA';

export const  COSTING_DETAIL_EDIT_DATA= 'COSTING_DETAIL_EDIT_DATA';

export const DELETE_COSTING_DETAIL_REQUEST = 'DELETE_COSTING_DETAIL_REQUEST';
export const DELETE_COSTING_DETAIL_SUCCESS = 'DELETE_COSTING_DETAIL_SUCCESS';
export const DELETE_COSTING_DETAIL_FAILURE = 'DELETE_COSTING_DETAIL_FAILURE';

export const UPDATE_COSTING_ASSIGN_USER_REQUEST = 'UPDATE_COSTING_ASSIGN_USER_REQUEST';
export const UPDATE_COSTING_ASSIGN_USER_SUCCESS = 'UPDATE_COSTING_ASSIGN_USER_SUCCESS';
export const UPDATE_COSTING_ASSIGN_USER_FAILURE = 'UPDATE_COSTING_ASSIGN_USER_FAILURE';

export const FETCH_COSTING_COMPARISION_DATA_REQUEST = 'FETCH_COSTING_COMPARISION_DATA_REQUEST';
export const FETCH_COSTING_COMPARISION_DATA_SUCCESS = 'FETCH_COSTING_COMPARISION_DATA_SUCCESS';
export const FETCH_COSTING_COMPARISION_DATA_FAILURE = 'FETCH_COSTING_COMPARISION_DATA_FAILURE';

export const FETCH_COSTING_INVOICE_PRINT_DATA_REQUEST = 'FETCH_COSTING_INVOICE_PRINT_DATA_REQUEST';
export const FETCH_COSTING_INVOICE_PRINT_DATA_SUCCESS = 'FETCH_COSTING_INVOICE_PRINT_DATA_SUCCESS';
export const FETCH_COSTING_INVOICE_PRINT_DATA_FAILURE = 'FETCH_COSTING_INVOICE_PRINT_DATA_FAILURE'